/*
 * Collection schemas for the SAMURAI admin.
 * Each field describes how to render it in the edit form.
 * Types: 'text', 'number', 'image', 'textarea', 'array-string', 'array-image'.
 */

const commonOrder = { key: "order", label: "Order", type: "number" };

export const COLLECTIONS = [
  {
    key: "films",
    label: "Films",
    columns: ["title", "type", "year", "director", "agency"],
    fields: [
      { key: "id", label: "Slug / ID", type: "text", helper: "Lowercase, unique. e.g. love_beauty_planet" },
      { key: "title", label: "Title", type: "text", required: true },
      { key: "type", label: "Type", type: "text", helper: "Hybrid / AI-led / Content Engine" },
      { key: "year", label: "Year", type: "number" },
      { key: "director", label: "Director", type: "text" },
      { key: "directorLabel", label: "Director Label", type: "text", helper: "Optional, e.g. 'Gen AI Dir'" },
      { key: "agency", label: "Agency", type: "text" },
      { key: "youtubeId", label: "YouTube ID", type: "text", helper: "The 11-character video ID from the URL" },
      { key: "image", label: "Thumbnail image", type: "image" },
      { key: "imageFallback", label: "Fallback image URL", type: "text" },
      commonOrder,
    ],
  },
  {
    key: "releases",
    label: "Latest Releases",
    columns: ["title", "type", "director", "agency"],
    fields: [
      { key: "id", label: "Slug / ID", type: "text" },
      { key: "title", label: "Title", type: "text", required: true },
      { key: "type", label: "Type", type: "text" },
      { key: "director", label: "Director", type: "text" },
      { key: "agency", label: "Agency", type: "text" },
      { key: "youtubeId", label: "YouTube ID", type: "text" },
      { key: "image", label: "Thumbnail image", type: "image" },
      { key: "imageFallback", label: "Fallback image URL", type: "text" },
      commonOrder,
    ],
  },
  {
    key: "prints",
    label: "Print",
    columns: ["title", "aspect"],
    fields: [
      { key: "id", label: "Slug / ID", type: "text" },
      { key: "title", label: "Title", type: "text", required: true },
      { key: "aspect", label: "Aspect ratio", type: "text", helper: "e.g. 5 / 3, 16 / 9" },
      { key: "hero", label: "Hero image", type: "image" },
      { key: "images", label: "Carousel images", type: "array-image" },
      commonOrder,
    ],
  },
  {
    key: "brands",
    label: "Brands / Partners",
    columns: ["name", "domain"],
    fields: [
      { key: "id", label: "Slug / ID", type: "text" },
      { key: "name", label: "Name", type: "text", required: true },
      { key: "logo", label: "Logo image", type: "image" },
      { key: "domain", label: "Domain (Clearbit fallback)", type: "text" },
      commonOrder,
    ],
  },
  {
    key: "viral_social",
    label: "Viral & Social",
    columns: ["title", "type", "director"],
    fields: [
      { key: "id", label: "Slug / ID", type: "text" },
      { key: "title", label: "Title", type: "text", required: true },
      { key: "type", label: "Type", type: "text" },
      { key: "year", label: "Year", type: "number" },
      { key: "director", label: "Director", type: "text" },
      { key: "directorLabel", label: "Director Label", type: "text" },
      { key: "video", label: "Video (mp4)", type: "image", helper: "Uploads mp4 too" },
      commonOrder,
    ],
  },
  {
    key: "team",
    label: "Team",
    columns: ["name", "role", "email"],
    fields: [
      { key: "id", label: "Slug / ID", type: "text" },
      { key: "name", label: "Name", type: "text", required: true },
      { key: "role", label: "Role", type: "text" },
      { key: "email", label: "Email", type: "text", helper: "Publicly shown under the role on the About page" },
      commonOrder,
    ],
  },
  {
    key: "capabilities",
    label: "Capabilities",
    columns: ["title", "subtitle"],
    fields: [
      { key: "id", label: "Slug / ID", type: "text", helper: "Used in the URL, e.g. hybrid → /capabilities/hybrid" },
      { key: "number", label: "Number", type: "text", helper: "e.g. 01, 02, 03" },
      { key: "title", label: "Title", type: "text", required: true },
      { key: "subtitle", label: "Subtitle", type: "text" },
      { key: "description", label: "Short description (Capabilities overview)", type: "textarea" },
      { key: "video", label: "Video", type: "image" },
      { key: "image", label: "Fallback image", type: "text" },
      { key: "is_coming_soon", label: "Coming Soon (detail page)", type: "text", helper: "Set to 'false' when the full detail page is ready. Default is true." },
      { key: "detail_body", label: "Full detail body (shown once Coming Soon is false)", type: "textarea" },
      { key: "detail_image", label: "Detail hero image", type: "image" },
      commonOrder,
    ],
  },
  {
    key: "nav_links",
    label: "Nav Links",
    columns: ["label", "path"],
    fields: [
      { key: "id", label: "Slug / ID", type: "text" },
      { key: "label", label: "Label", type: "text", required: true },
      { key: "path", label: "Path", type: "text", helper: "Route path e.g. /work" },
      commonOrder,
    ],
  },
  {
    key: "disciplines",
    label: "Artist Disciplines",
    columns: ["name"],
    fields: [
      { key: "id", label: "Slug / ID", type: "text" },
      { key: "name", label: "Name", type: "text", required: true },
      commonOrder,
    ],
  },
];
